import { render } from "./topOffices.vue?vue&type=template&id=6b3ea1fe&scoped=true"
import script from "./topOffices.vue?vue&type=script&lang=js"
export * from "./topOffices.vue?vue&type=script&lang=js"

import "./topOffices.vue?vue&type=style&index=0&id=6b3ea1fe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3ea1fe"]])

export default __exports__